import { PageUnauthorised } from '@components/app/PageUnauthorised'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/unauthorised')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PageUnauthorised />
}
